import { memo } from 'react'
import { Box } from '@mui/material'

/**
 * AnimatedBox component - Light fade-in for quick perceived load.
 * Supports staggerIndex for list items and variant (fade vs fadeUp).
 * Keyframes are defined in src/index.css.
 *
 * @param {number} delay - Animation delay in seconds
 * @param {number} staggerIndex - If provided, delay = staggerIndex * 0.1 (overrides delay)
 * @param {string} variant - 'fade' (opacity only) or 'fadeUp' (opacity + translateY)
 * @param {number} duration - Animation duration in seconds (default: 0.2 for fade, 0.5 for fadeUp)
 */
export const AnimatedBox = memo(({
  children,
  delay = 0,
  staggerIndex,
  variant = 'fade',
  duration,
  sx,
  ...props
}) => {
  const effectiveDelay = staggerIndex != null ? staggerIndex * 0.1 : delay
  const effectiveDuration = duration ?? (variant === 'fadeUp' ? 0.5 : 0.2)
  const animationName = variant === 'fadeUp' ? 'fadeInUp' : 'fadeIn'

  return (
    <Box
      sx={{
        animation: `${animationName} ${effectiveDuration}s ease-out ${effectiveDelay}s both`,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  )
})
